<template>
  <div v-if="shouldRenderConfig" :class="[getClassName, getDisabledClass]">
    <div
      @click="resetClickedLastPageOption"
      :class="getClassName + 'HeaderContainer'"
    >
      <button
        type="button"
        class="btn btn-primary"
        :class="activeClass()"
        @click="onClickSelectPageOption(code)"
      >
        <div :class="getClassName + 'Index'">
          {{ index + 1 }}
        </div>
        <div :class="getClassName + 'Label'">
          {{ name }}
        </div>
        <img
          :class="getClassName + 'Toggle'"
          :src="getBaseUrl + `images/matrix/red_plus.svg`"
          v-show="!getIsOpen"
        />
        <img
          :class="getClassName + 'Toggle'"
          :src="getBaseUrl + `images/matrix/minus_line.svg`"
          v-show="getIsOpen"
        />
        <!-- <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
        <appAwesomeIcon
          v-if="getIsShowCheckedPageOptionFlag && checked"
          icon="check"
          useClass="pageOptionCheck"
        /> -->
      </button>
    </div>
    <div v-if="getIsOpen">
      <appPageOptionAttributesContainer
        :code="code"
      ></appPageOptionAttributesContainer>
    </div>
  </div>
</template>
<script>
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useConfigStore } from "@/stores/modules/config";
import { useTooltipsStore } from "@/stores/modules/tooltips";
import { useCheckedPageOptionsStore } from "@/stores/modules/checkedPageOptions";
import { mapState, mapActions } from "pinia";
import { useUrlsStore } from "@/stores/modules/urls";

export default {
  computed: {
    ...mapState(useConfigStore, ["getPageAttributesInPageOptions"]),
    ...mapState(useWebproductStore, [
      "getActivePageOptionsForPP",
      "getLastPageOptions",
      "getClickedLastPageOption"
    ]),
    ...mapState(useTooltipsStore, ["getShowTooltipsInPOHeader"]),
    ...mapState(useUrlsStore, ["getBaseUrl"]),
    ...mapState(useCheckedPageOptionsStore, [
      "getChecked",
      "getCheckedIsNext",
      "getIsShowCheckedPageOptionFlag",
      "getIsCheckedPageOptionActive"
    ]),
    name: function () {
      return this.propsData.label;
    },
    tooltip: function () {
      return this.getShowTooltipsInPOHeader && this.propsData.tooltip;
    },
    checked: function () {
      return this.getChecked(this.index);
    },
    getIsOpen: function () {
      const activePageOptions = this.getActivePageOptionsForPP(this.ppcode);
      const currentCode = this.code;
      if (
        this.getLastPageOptions.includes(currentCode) &&
        this.getClickedLastPageOption
      ) {
        return false;
      }
      return activePageOptions === currentCode;
    },
    getDisabledClass: function () {
      if (!this.getIsCheckedPageOptionActive) {
        return "";
      }
      return this.checked || this.getCheckedIsNext(this.index)
        ? ""
        : "disabled";
    }
  },

  methods: {
    ...mapActions(useWebproductStore, [
      "setActiveProductPageOption",
      "setClickedLastPageOption"
    ]),
    resetClickedLastPageOption: function () {
      this.setClickedLastPageOption(false);
    },
    onClickSelectPageOption(option) {
      this.setActiveProductPageOption({ ppcode: this.ppcode, option });
    },
    activeClass: function () {
      return this.getActivePageOptionsForPP(this.ppcode) == this.code
        ? "active"
        : "";
    }
  },
  props: ["propsData", "index", "code", "ppcode"]
};
</script>
